import React from 'react';
import PropTypes from 'prop-types';

import { texts } from 'utils/languages/fr';

import { ActionButton, CustomDialogTitle } from 'components';
import { Dialog, DialogContent, DialogContentText, DialogActions, Box } from '@mui/material';
import { useSmallScreen } from 'utils/hooks/ui';

const InfoDialog = props => {
    const {
        handleClose,
        message,
        title,
        open = false,
        withCloseButton,
        loading,
        handleCloseButton,
        ...rest
    } = props;
    const fullScreen = useSmallScreen();

    return (
        <Dialog
            fullScreen={fullScreen}
            sx={theme => ({ [theme.breakpoints.down('sm')]: { minWidth: 'unset' } })}
            open={open}
            {...rest}
        >
            <CustomDialogTitle handleClose={handleClose} title={title} />
            <DialogContent sx={{ padding: '30px' }}>
                {React.isValidElement(message) ? (
                    <Box sx={{ color: 'grey.600' }}>{message}</Box>
                ) : (
                    <DialogContentText sx={{ color: 'grey.600' }}>{message}</DialogContentText>
                )}
            </DialogContent>
            {withCloseButton && (
                <DialogActions>
                    <ActionButton loading={loading} disabled={loading} onClick={handleCloseButton}>
                        {texts.CLOSE}
                    </ActionButton>
                </DialogActions>
            )}
        </Dialog>
    );
};

InfoDialog.propTypes = {
    handleClose: PropTypes.func.isRequired,
    message: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    withCloseButton: PropTypes.bool,
    loading: PropTypes.bool,
    handleCloseButton: PropTypes.func,
};

export default InfoDialog;
